<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="chapterTitle"><a href="#/toc01#chap_03" id="chap03">ARE THERE ANY UNDISCOVERED ANIMALS?</a></p>
<p class="chapterAuthor">Sir David Attenborough</p>
<p class="subhead">naturalist</p>
<p class="paraNoIndent">Yes. Hundreds. Probably thousands. Exactly how many no one can say – because they have not yet been discovered.</p>
<p class="para">If you spent a day in a tropical rainforest, swishing a butterfly net around through the undergrowth or the leaves high in the tree canopy, you would certainly collect hundreds of insects. Many of them would be beetles. Would any of them be unknown to science? You would have to ask a beetle scientist. Many he would recognise straight away. But there might be a few that would puzzle him.</p>
<p class="para">Would they be new species? It might take him a long time in a museum, examining them and comparing them with others in the museum or pictured in books about beetles, to be quite certain that he had a new species. But there would probably be one. In fact, I suspect it might be harder to find a beetle scientist who would be able to do this very difficult work than to find an unknown beetle.</p>
<p class="para">Unknown big animals are certainly much rarer. Your best chance of finding one would be to go to the least explored part of our planet – the very deep sea. You can only go down there in special deep-sea submarines. They have to be extremely strong to withstand the huge pressure of the water. And of course it is pitch black down there, so you would have to have powerful lights to do your searching.</p>
<p class="para">You might get a glimpse of something in their beams, but unless you could catch it and examine it in detail, you could not be certain that it was a new species. And catching animals down there is a very difficult job, needing very specialised equipment. But I am sure there are still monsters down there that no one has ever seen before.</p>
<p class="para"> </p>
<p class="para"> </p>
<p class="image"><img alt="image" src="images/2_1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap03.vue?1698fac0